// bao migrate skip
import "./../../services/bao-router";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";

class ServiceRecordReportViewModel {
    constructor(parent: any) {
        this.parent = parent;
        this._initialized = false;
        this.AllProjects.subscribe((value) => {
            if (value) {
                this.ProjectNumber("");
                this.ProjectId(null);
            }
        });
    }
    parent: any;
    Bao = Bao;
    private _initialized: boolean;
    ConfigurationItemId: KnockoutObservable<string> = ko.observable(null);
    PersonFullName: KnockoutObservable<string> = ko.observable("");
    ProjectId: KnockoutObservable<string> = ko.observable(null);
    ProjectNumber: KnockoutObservable<string> = ko.observable("");
    AllProjects: KnockoutObservable<boolean> = ko.observable(false);
    FromDateJs: KnockoutObservable<string> = ko.observable("");
    ToDateJs: KnockoutObservable<string> = ko.observable("");
    ShowRemark: KnockoutObservable<boolean> = ko.observable(false);
    ShowActivityTypeName: KnockoutObservable<boolean> = ko.observable(false);
    Download() {

        if (!this.IsValidDateFields()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }

        if (this.ConfigurationItemId() == null || (this.AllProjects() == false && this.ProjectId() == null) || Bao.Utils.String.IsNullOrWhitespace(this.FromDateJs()) || Bao.Utils.String.IsNullOrWhitespace(this.ToDateJs())) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            this.parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/ServiceRecordReportDownload", JSON.stringify({
                personId: this.ConfigurationItemId(),
                projectId: this.ProjectId(),
                fromDate: this.FromDateJs(),
                toDate: this.ToDateJs(),
                showRemark: this.ShowRemark(),
                showActivityTypeName: this.ShowActivityTypeName(),
                reportTemplateId: null
            }), (result) => {
                this.parent.TabPage.IsLoading(false);
                if (result.Result == true) {
                    baoRouter.setHash("document/" + result.Message);
                }
            });
        }
    }
    init() {
        return Bao.post("SynosetReportCenter/ServiceRecordReportGetDefaultData", (result) => {
            ko.map.fromJS(result, this);
            this._initialized = true;
        });
    }


    IsValidDateFields () {
        return Boolean(Bao.Utils.String.IsNullOrEmpty(this.FromDateJs()) || Bao.Utils.String.IsNullOrEmpty(this.ToDateJs()) || Number(this.ToDateJs()) >= Number(this.FromDateJs()));
    };

    ;
    loaded() {
        //Dashboard laden
        var currentDate = new Date();
    }
    ;
}
export default ServiceRecordReportViewModel;